import React, { useEffect, useRef, useState, useCallback } from 'react';

const Logos = React.memo(() => (
  <div className="main-logo">
    <img
      src={`${process.env.PUBLIC_URL}/images/logo-normal.svg`}
      className="header-brand-img desktop-logo"
      alt="logo"
    />
    <img
      src={`${process.env.PUBLIC_URL}/images/parking_p.png`}
      className="header-brand-img icon-logo"
      alt="logo"
    />
    <img
      src={`${process.env.PUBLIC_URL}/images/logo-white.svg`}
      className="header-brand-img desktop-logo theme-logo"
      alt="logo"
    />
    <img
      src={`${process.env.PUBLIC_URL}/images/parking_f.png`}
      className="header-brand-img icon-logo theme-logo"
      alt="logo"
    />
  </div>
));

const LoadingPage = () => {
  const [progress, setProgress] = useState(10);
  const timerRef = useRef(null);

  const tick = useCallback(() => {
    setProgress((p) => (p < 90 ? p + 10 : p));
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(tick, 1000);
    return () => clearInterval(timerRef.current);
  }, [tick]);

  return (
    <div className="page">
      <div className="container-fluid">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '25%',
            margin: 'auto',
            height: '100vh',
            minWidth: 280,
          }}
        >
          <Logos />

          <div className="progress mg-b-10 my-5" style={{ width: '100%' }}>
            <div
              className="progress-bar progress-bar-striped progress-bar-animated bg-secondary"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: `${progress}%` }}
            >
              {progress}%
            </div>
          </div>

          <div>
            <b>Loading PMIS...</b>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
